import * as actions from './actionConstants';

export const getSeasons = () => ({
	type: actions.GET_SEASONS
});

export const getAllSeasons = () => ({
	type: actions.GET_ALL_SEASONS
});

export const getAllSeasonsSuccess = (seasonsList, seasons) => ({
	type: actions.GET_ALL_SEASONS_SUCCESS,
	seasonsList,
	seasons
});

export const getSeasonsSuccess = (seasonsList, seasons) => ({
	type: actions.GET_SEASONS_SUCCESS,
	seasonsList,
	seasons
});

export const getSeasonsError = error => ({
	type: actions.GET_SEASONS_ERROR,
	error
});

export const getSeasonsByActive = activeSeason => ({
	type: actions.GET_SEASONS_BY_ACTIVE,
	activeSeason
});

export const getSeasonsByDisplay = displaySeason => ({
	type: actions.GET_SEASONS_BY_DISPLAY,
	displaySeason
});

export const updateSeasonMaxDate = (seasonId, maxDate) => ({
	type: actions.UPDATE_SEASON_MAX_DATE,
	seasonId,
	maxDate
});

export const updateSeasonMaxDateSuccess = (seasonId, maxDate) => ({
	type: actions.UPDATE_SEASON_MAX_DATE_SUCCESS,
	seasonId,
	maxDate
  });
  
export const updateSeasonMaxDateError = (seasonId, error) => ({
	type: actions.UPDATE_SEASON_MAX_DATE_ERROR,
	seasonId,
	error
  });

export const updateSeasonActive = (seasonId, active) => ({
	type: actions.UPDATE_SEASON_ACTIVE,
	seasonId,
	active
});

export const updateSeasonActiveSuccess = (seasonId, active) => ({
	type: actions.UPDATE_SEASON_ACTIVE_SUCCESS,
	seasonId,
	active
  });

export const updateSeasonActiveError = (seasonId, error) => ({
	type: actions.UPDATE_SEASON_ACTIVE_ERROR,
	seasonId,
	error
  });

export const updateSeasonDisplay = (seasonId, display) => ({
	type: actions.UPDATE_SEASON_DISPLAY,
	seasonId,
	display
});

export const updateSeasonDisplaySuccess = (seasonId, display) => ({
	type: actions.UPDATE_SEASON_DISPLAY_SUCCESS,
	seasonId,
	display
});

export const updateSeasonDisplayError = (seasonId, error) => ({
	type: actions.UPDATE_SEASON_DISPLAY_ERROR,
	seasonId,
	error
});

/*export const getSeasonsByActiveSuccess = (seasonsList, seasons) => ({
	type: actions.GET_SEASONS_BY_ACTIVE_SUCCESS,
	seasonsList,
	seasons
});

export const getSeasonsByActiveError = error => ({
	type: actions.GET_SEASONS_BY_ACTIVE_ERROR,
	error
});
*/



// WEBPACK FOOTER //
// ./src/actions/seasonActions.js